import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const hourlyRentalCities = [
  { title: "Mumbai", description: "Maharashtra, India", price: "₹999", imageUrl: "https://www.easemytrip.com/cabs/img/delhi-car.png" },
  { title: "Sambhajinagar", description: "Maharashtra, India", price: "₹849", imageUrl: "https://www.easemytrip.com/cabs/img/Bangaluru-car.png" },
  { title: "Nashik", description: "Maharashtra, India", price: "₹799", imageUrl: "https://www.easemytrip.com/cabs/img/Ahmedabad-car.png" },
  { title: "Pune", description: "Maharashtra, India", price: "₹899", imageUrl: "https://www.easemytrip.com/cabs/img/jaipur.png" },
  { title: "Mahabaleshwar", description: "Maharashtra, India", price: "₹1,199", imageUrl: "https://www.easemytrip.com/cabs/img/varansi.png" },
];

function Slider_2_Cabs() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: screenWidth <= 320 ? 2 : 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      { breakpoint: 320, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
    ],
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getDynamicClass = () => {
    if (screenWidth <= 480) return "swipper-cabs-small";
    if (screenWidth <= 768) return "swipper-cabs-medium";
    if (screenWidth <= 1024) return "swipper-cabs-large";
    return "swipper-cabs-default";
  };

  return (
    <section className="popular-state pt-5 holidays-left">
      <div className="container">
        <div className="title">
          <h3><span>Flexible </span> Hourly Car Rentals in India</h3>
          <p className="mb-4">Rent a car by the hour for convenient and affordable travel within major Indian cities. Enjoy the freedom to explore at your own pace.</p>
        </div>
        <div className={`cabs_slider customer-logos slider airport-transfer-slide-sec slider-cabs ${isScrolled ? "slide" : ""} ${getDynamicClass()}`}>
          <Slider {...settings}>
            {hourlyRentalCities.map((city) => (
              <div className="slide" style={{ width: "155px" }} key={city.title}>
                <div className="post-item">
                  <div className="post__img">
                    <a href="/cabs">
                      <img src={city.imageUrl} alt={`${city.title} hourly rental car`} loading="lazy" />
                    </a>
                  </div>
                  <div className="post__body">
                    <div className="post__meta-cat">
                      <div className="ttl-text-book">
                        <div className="ttl-text d-flex justify-content-space-between gap-3">
                          <div className="left">
                            <h5>{city.title}</h5>
                            <p>{city.description}</p>
                          </div>
                          <div className="right">
                            <div className="img">
                              <img src="https://www.easemytrip.com/cabs/img/copy-clock.svg" alt="Hourly rental" />
                            </div>
                          </div>
                        </div>
                        <div className="book-wrap">
                          <a href="/cabs" onClick={() => window.scrollTo(0, 0)}>
                            <div className="book-list d-flex justify-content-space-between align-items-center">
                              <div className="book"><p>From <span>{city.price}</span></p></div>
                              <div className="book-link">
                                <span className="book">Book <img src="https://www.easemytrip.com/cabs/img/arrow-yellow.png" alt="" /></span>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Slider_2_Cabs;
